import { useState } from "react";
import { Button } from "@/components/ui/button";
import GuestClaimModal from "@/components/GuestClaimModal";
import { Eye, ShieldCheck } from "lucide-react";

// Read-only-Hinweis für Gäste auf Finanzen/Steuern: Bereich ist zur Ansicht geöffnet,
// Bearbeiten/Anlegen führt zum "Konto sichern"-Moment.
export default function GuestReadOnlyBanner() {
  const [claimOpen, setClaimOpen] = useState(false);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4 w-full" data-testid="guest-readonly-banner">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
        <div className="flex items-start gap-2 text-sm text-amber-900 flex-grow">
          <Eye className="h-4 w-4 mt-0.5 shrink-0 text-amber-600" />
          <span>
            <strong>Read-only in der Demo:</strong> Dieser Bereich zeigt echte Beispielzahlen – Steuer-Rücklage, USt-Voranmeldung und Fristen.
            Zum Erfassen eigener Belege &amp; Daten sichere dein Konto.
          </span>
        </div>
        <Button
          size="sm"
          onClick={() => setClaimOpen(true)}
          className="bg-emerald-600 hover:bg-emerald-700 text-white shrink-0"
          data-testid="guest-readonly-claim-btn"
        >
          <ShieldCheck className="h-4 w-4 mr-1.5" />
          Konto sichern
        </Button>
      </div>
      <GuestClaimModal open={claimOpen} onOpenChange={setClaimOpen} />
    </div>
  );
}
